/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { MapCommand } from '../map-command.class';

export class ZoomOutCommand extends MapCommand {

    invoke() {
        this.deps['interactions'].enableZoomOutInteraction();
    }
}
